/**
 * <TutorApplicationRecordingPage> — l'enregistrement d'une réponse vidéo (page).
 *
 * La caméra (`<TutorVideoRecorder>`) et ses deux confirmations, celles de l'ancien
 * `VideoRecordingScreen` : la croix demande « Veux-tu vraiment quitter ? » (la réponse ne sera pas
 * enregistrée) — la même sortie que les autres pages de la candidature (`exitConfirm`) —, et
 * « Terminer » demande « Veux-tu vraiment terminer l'enregistrement ? » (elle le sera,
 * `finishConfirm`).
 */
import React from "react"

import { ConfirmDialog } from "../../molecules/ConfirmDialog"
import { TutorVideoRecorder, type TutorVideoRecorderProps } from "../../organisms/TutorVideoRecorder"
import {
    TutorApplicationExitDialog,
    type TutorApplicationExitConfirm,
} from "../TutorApplicationQuestionPage/TutorApplicationQuestionPage"

const TUTOR_APPLICATION_RECORDING_TEXTS = {
    finishTitle: "Veux-tu vraiment terminer l'enregistrement ?",
    finishMessage: "Ta réponse sera enregistrée",
    finishConfirm: "Terminer",
    cancel: "Annuler",
}

export type TutorApplicationRecordingPageProps = TutorVideoRecorderProps & {
    /** La croix : « Veux-tu vraiment quitter ? », ouverte. */
    exitConfirm?: TutorApplicationExitConfirm
    /** « Terminer » : « Veux-tu vraiment terminer l'enregistrement ? », ouverte. */
    finishConfirm?: { visible: boolean; onConfirm: () => void; onCancel: () => void }
}

export function TutorApplicationRecordingPage(props: TutorApplicationRecordingPageProps) {
    const { exitConfirm, finishConfirm, ...recorder } = props

    return (
        <>
            <TutorVideoRecorder {...recorder} />
            {exitConfirm != null && <TutorApplicationExitDialog exitConfirm={exitConfirm} />}
            {finishConfirm != null && (
                <ConfirmDialog
                    visible={finishConfirm.visible}
                    title={TUTOR_APPLICATION_RECORDING_TEXTS.finishTitle}
                    message={TUTOR_APPLICATION_RECORDING_TEXTS.finishMessage}
                    confirmLabel={TUTOR_APPLICATION_RECORDING_TEXTS.finishConfirm}
                    cancelLabel={TUTOR_APPLICATION_RECORDING_TEXTS.cancel}
                    danger={false}
                    onConfirm={finishConfirm.onConfirm}
                    onCancel={finishConfirm.onCancel}
                />
            )}
        </>
    )
}
